<script setup lang="ts">
    /**
     * USP widget container
     * renders a list of USP info blocks
     *
     * 📘docs: https://onewoom.atlassian.net/wiki/spaces/ECOM/pages/152045096
     */
    const props = defineProps<IWidgetProps<UspWidgetData>>();

    const { data, getValueSequence, cmsComponentProps } = useWidget(props);

    const sequence = getValueSequence(data.value);
</script>
<template>
    <mol-usp-bar
        :sequence="sequence"
        v-bind="cmsComponentProps" />
</template>
